"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var pp_react_1 = require("@paypalcorp/pp-react");
/**
 * @react-component Spinner - overlay spinner
 *
 */
function Spinner() {
    return (React.createElement(pp_react_1.LoadingSpinner, { className: "panelSpinnerNew", screenReaderText: "loading", size: "lg" }));
}
exports.default = Spinner;
